/**
 * Marcadores do texto da campanha. Lista FECHADA e igual a da API
 * (BroadcastPlaceholders.cs): o Master so ajuda a escrever, quem troca e o
 * servidor, na hora de mostrar para cada pessoa.
 */
export const PLACEHOLDER_NAME = '{nome}';

export const BROADCAST_PLACEHOLDERS = [
  { token: PLACEHOLDER_NAME, label: 'Primeiro nome de quem vê o aviso' },
];

export const PLACEHOLDER_SAMPLE_NAME = 'Maria';

/**
 * Insere o marcador na posicao do cursor, com espaco antes/depois so quando
 * falta — e sem separar o marcador da pontuacao que vem logo depois.
 */
export const insertPlaceholderAt = (text, caret, token) => {
  const value = text || '';
  const at = caret == null || caret < 0 || caret > value.length ? value.length : caret;
  const before = value.slice(0, at);
  const after = value.slice(at);
  const lead = before && !/\s$/.test(before) ? ' ' : '';
  const trail = after && !/^[\s,.;:!?]/.test(after) ? ' ' : '';
  const head = before + lead + token;
  return { text: head + trail + after, caret: head.length };
};

/**
 * Decide em qual campo e em qual posicao o marcador deve entrar.
 *
 * Quando o elemento focado no momento do clique no chip E o campo que
 * lastField ja aponta (o caso normal: @mousedown.prevent no chip nunca tira o
 * foco do campo), usa a posicao AO VIVO do cursor (`activeCaret`) em vez da
 * `lastCaret` congelada no ultimo @blur — assim cliques repetidos no chip
 * continuam inserindo no lugar certo. Fora desse caso (por exemplo o campo
 * ativo nao e um input rastreado, como o editor do corpo), cai para
 * lastField/lastCaret.
 */
export const resolveInsertTarget = (lastField, activeFieldName, activeCaret, lastCaret) => {
  if (activeFieldName) {
    return { field: activeFieldName, caret: activeCaret };
  }
  return { field: lastField, caret: lastCaret };
};

/** Previa do Master: mostra um nome de exemplo no lugar do marcador. */
export const fillPreview = (text) =>
  String(text || '').replace(/\{nome\}/gi, PLACEHOLDER_SAMPLE_NAME);



// WEBPACK FOOTER //
// ./src/vue/pages/restricted/broadcast/broadcastPlaceholders.js